import { render, staticRenderFns } from "./StaticsTable.vue?vue&type=template&id=783a1b08&scoped=true&"
import script from "./StaticsTable.vue?vue&type=script&lang=js&"
export * from "./StaticsTable.vue?vue&type=script&lang=js&"
import style0 from "./StaticsTable.vue?vue&type=style&index=0&id=783a1b08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783a1b08",
  null
  
)

export default component.exports